import type { Transaction } from '@chikara/types';


interface TransferRequest {
  fromAccountId: string;
  toAccountCbu: string;
  amount: number;
  description: string;
}

interface ValidateCbuResponse {
  valid: boolean;
  holderName?: string;
  bankName?: string;
}

export const transferService = {
  async createTransfer(data: TransferRequest): Promise<Transaction> {
    // Demo - in production, call the actual API
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    return {
      id: Math.random().toString(36).substring(7),
      accountId: data.fromAccountId,
      type: 'transfer',
      status: 'completed',
      amount: data.amount,
      currency: 'ARS',
      description: data.description,
      counterparty: {
          cbu: data.toAccountCbu,
          name: ''
      },
      createdAt: new Date().toISOString(),
      completedAt: new Date().toISOString(),
    };

    // Production:
    // return apiClient.post<Transaction>(API_ENDPOINTS.transfers.create, data);
  },

  async validateCbu(cbu: string): Promise<ValidateCbuResponse> {
    // Demo
    await new Promise(resolve => setTimeout(resolve, 300));
    
    if (cbu.length !== 22) {
      return { valid: false };
    }
    
    return {
      valid: true,
      holderName: 'Juan Pérez',
      bankName: 'Banco Demo',
    };

    // Production:
    // return apiClient.post<ValidateCbuResponse>(API_ENDPOINTS.transfers.validate, { cbu });
  },
};
